import { ClientAreaApiClient, CustomerTrackingDto } from 'common/api/autogenerated/client-area';
import { ClientAuthApiClient, SignInDto } from 'common/api/autogenerated/client-auth';
import { CreateOrUpdateCustomerSettingsDto, TradingGatewayApiClient } from 'common/api/autogenerated/trading-gateway';

const clientAuthApiClient = new ClientAuthApiClient({
  BASE: '/auth',
  WITH_CREDENTIALS: true,
});
const clientAreaApiClient = new ClientAreaApiClient({
  BASE: '/client-area',
  WITH_CREDENTIALS: true,
});
const tradingGatewayApiClient = new TradingGatewayApiClient({
  BASE: '/trading-gateway',
  WITH_CREDENTIALS: true,
});

export const postLogin = (data: SignInDto) => clientAuthApiClient.auth.postV1AuthSignIn(data);
export const postLogout = () => {
  try {
    sessionStorage.clear();
  } catch (e) {
    console.log(e);
  }
  return clientAuthApiClient.auth.postV1AuthSignOut();
};
export const getCurrentUser = () => clientAreaApiClient.user.getApiAccountsCurrentuser();
export const getSettings = () => clientAreaApiClient.settings.getApiSettings();
export const getCustomerSettings = () => tradingGatewayApiClient.customerSettings.getV1CustomerSettings();
export const setCustomerSettings = (data: CreateOrUpdateCustomerSettingsDto) =>
  tradingGatewayApiClient.customerSettings.patchV1CustomerSettings(data);
export const getVerificationLimits = () => clientAreaApiClient.settings.getApiSettingsVerificationLimits();
export const getTier = () => clientAreaApiClient.loyaltyProgram.getApiLoyaltyProgramUserInfo();
export const getTiers = () => clientAreaApiClient.loyaltyProgram.getApiLoyaltyProgramTiers();
export const postRemarketing = (data: CustomerTrackingDto[]) => clientAreaApiClient.user.postApiAccountsTracking(data);
export const getVerificationLevelStates = () => clientAreaApiClient.user.getApiAccountsVerificationLevel();
